import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './DownloadAppButton.module.css';

export const DownloadAppButton = ({ className = '', customTitle, customSubtitle, showVersionDetails = false }) => {
  const [showModal, setShowModal] = useState(false);
  const [appInfo, setAppInfo] = useState(null);

  const APK_DOWNLOAD_URL = 'https://apk-service.vercel.app/api/app/download';
  const APK_VERSION_URL = 'https://apk-service.vercel.app/api/app/version/latest';

  useEffect(() => {
    fetch(APK_VERSION_URL)
      .then((res) => res.json())
      .then((data) => {
        if (data && data.latestVersion) {
          setAppInfo(data);
        }
      })
      .catch((err) => console.error('Erro ao buscar versão do APK:', err));
  }, []);

  const handleDownloadClick = () => {
    // Exibe o modal de orientação ao clicar no download
    setShowModal(true);
  };

  const badgeText = appInfo?.latestVersion ? `v${appInfo.latestVersion}` : 'Grátis';

  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.buttonWrapper}>
        <a
          href={APK_DOWNLOAD_URL}
          className={styles.downloadBtn}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleDownloadClick}
        >
          <div className={styles.iconWrapper}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
              <line x1="12" y1="18" x2="12.01" y2="18"></line>
            </svg>
          </div>
          <div className={styles.textWrapper}>
            <span className={styles.subtitle}>{customSubtitle || 'Baixe no celular Android'}</span>
            <span className={styles.title}>{customTitle || 'Baixar App Família (.APK)'}</span>
          </div>
          <div className={styles.badge}>{badgeText}</div>
        </a>

        {showVersionDetails && appInfo && (
          <div className={styles.versionDetailsBox}>
            <span className={styles.versionTag}>
              Versão v{appInfo.latestVersion}
              {appInfo.publishedAt && (
                <> &bull; Publicado em {new Date(appInfo.publishedAt).toLocaleDateString('pt-BR')}</>
              )}
            </span>
            {appInfo.changelog && (
              <p className={styles.changelogText}>
                <strong>Novidades:</strong> {appInfo.changelog.replace(/\*\*/g, '')}
              </p>
            )}
          </div>
        )}
      </div>

      {/* Modal de Instrução de Instalação (Renderizado via Portal no document.body para evitar descolocamento de layout) */}
      {showModal &&
        createPortal(
          <div className={styles.modalOverlay} onClick={() => setShowModal(false)}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <button 
                className={styles.closeBtn} 
                onClick={() => setShowModal(false)}
                aria-label="Fechar"
              >
                ×
              </button>

              <div className={styles.modalHeader}>
                <span className={styles.iconBadge}>📲</span>
                <h3>Iniciando Download do App</h3>
                {appInfo?.latestVersion && (
                  <span className={styles.modalVersionBadge}>
                    Versão {appInfo.latestVersion}
                  </span>
                )}
              </div>

              <div className={styles.stepsList}>
                <div className={styles.stepItem}>
                  <span className={styles.stepNum}>1</span>
                  <p>
                    Você será direcionado para a página oficial do <strong>Google Firebase</strong>.
                  </p>
                </div>

                <div className={styles.stepItem}>
                  <span className={styles.stepNum}>2</span>
                  <p>
                    Clique no botão <strong>"Instalar"</strong> para instalar o App Família com segurança.
                  </p>
                </div>

                <div className={styles.stepItem}>
                  <span className={styles.stepNum}>3</span>
                  <p>
                    Abra o app no seu celular para acompanhar a frequência e notas do seu filho!
                  </p>
                </div>
              </div>

              <button className={styles.confirmBtn} onClick={() => setShowModal(false)}>
                Entendi! Continuar
              </button>
            </div>
          </div>,
          document.body
        )}
    </div>
  );
};

export default DownloadAppButton;
